import config from '@lumiere/shared/config';
const DEFAULT_IMAGE = `${config.adminAppURL}/img/video_image_placeholder.jpg`;
/**
 * Optimizing the viewer-app image preview for mobile social share, in
 * addition to the beautiful rendition on Twitter and Iframe embed
 *
 * The open graph protocol for images when specified should have
 * the width and height attrs so that the images are rendered
 * immediately without having to be asynchronously downloaded
 * and processed. - https://bit.ly/3fL34uK
 *
 * - Facebook requires image:width|height greater than 600X314
 */
export default function getHead(headParams) {
    if (headParams) {
        const { title, description, image, url } = headParams;
        return `
    <title>${title}</title>
    <meta name="description" content="${description}">

    <meta property="og:type" content="video.other" />
    <meta property="og:title" content="${title}" />
    <meta property="og:url" content="${url}" />
    <meta property="og:description" content="${description}" />
    <meta property="og:image" content="${image}" />
    <meta property="og:image:alt" content="${description}">
    <meta property="og:image:width" content="720" />
    <meta property="og:image:height" content="540" />

    <meta name="twitter:card" content="summary_large_image">
    <meta name="twitter:url" content="${url}">
    <meta name="twitter:title" content="${title}">
    <meta name="twitter:description" content="${description}">
    <meta name="twitter:image" content="${image}">
    <meta name="twitter:image:alt" content="${description}">
    <link rel="alternate" type="application/json+oembed" href="${config.adminAppURL}/api/services/oembed?url=${url}&format=json" title="${title}" />
    <link href="https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900" rel="stylesheet" />
  `;
    }
    else {
        return `
      <title>Lumiere</title>
      <meta property="og:image" content="${DEFAULT_IMAGE}" />
      <meta property="og:image:width" content="720" />
      <meta property="og:image:height" content="540" />
      <meta name="twitter:image" content="${DEFAULT_IMAGE}">
    `;
    }
}
